import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '@/app/core/authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthForbiddenErrorService {
  authenticationService = inject(AuthenticationService);

  /**
   * This is a utility service to handle forbidden error responses.
   * It logs the user out so they will get a new token. Preferably we would use
   * a refresh token to get a new token and this process would not be necessary.
   * @param error
   */
  public handleError(error: HttpErrorResponse): void {
    // Right now I'm limiting this to 403 code, because that is what I've seen in the past.
    // There is probably a better way to handle this, so update this as needed.
    if (error.status === 403) {
      this.authenticationService.logout();
    }
  }
}
